import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  role: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserRole: (state, action) => {
      state.role = action.payload;
    },
    clearUserRole: state => {
      state.role = null;
    },
  },
});

export const { setUserRole, clearUserRole } = userSlice.actions;
export default userSlice.reducer;
